import { Component, OnInit, OnDestroy } from '@angular/core';
import { DashboardService } from '../dashboard/dashboard.service';
import { MatSnackBar } from '@angular/material';
import 'rxjs/add/operator/takeWhile';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SessionStorage } from 'ngx-webstorage';

@Component({
  selector: 'app-audit-log',
  templateUrl: './audit-log.component.html',
  styleUrls: ['./audit-log.component.css']
})
export class AuditLogComponent implements OnInit, OnDestroy {
  @SessionStorage() public config; 
  
  public auditlogList = []; // Array of object to store the List of Audits
  public pageNumber: number = 1; // Variable to store the current page number for pagination
  public totalElements: number; // A variable to store the Total audits for pagination count
  private alive: boolean = true; // A variable to unsubscribe the observable service call from Memory leak
  constructor(
    public dashboardService: DashboardService,
    public snackbar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService
  ) { }

  ngOnInit() {
    this.getAuditLogList();
  }

  /**
  * @function getAuditLogList
  * @desc
  * getAuditLogList is the function to get all the audit logs of the particular logged user
  * and display it in the table format for the end user.
  * @var auditlog variable to store the list obtained from the Backedn upon API call
  * @var totalElements The variable to store the total count of audit logs for pagination setup
  * @method post
  * @param pageNumber current page number choosen by the end user (Default set to 1)
  * @return null
  * @requires takeWhile An rxjs operator to subscribe the service
  * @author gaurav.rao
  **/

  getAuditLogList() {
    this.spinnerService.show();
    this.dashboardService.getAuditLog(this.pageNumber).takeWhile(() => this.alive).subscribe(
      (data) => {
        this.spinnerService.hide();
        if (Object.keys(data.payload).length !== 0) {
          this.auditlogList = data.payload.auditlogs;
          this.totalElements = data.payload.totalauditlogs;
        }
      }, (error) => {
        this.spinnerService.hide();
        this.snackbar.open('Error occured while retriving the Audit list', '', {
          duration: 3000
        });
      });
  }

  /**
  * @function triggerChange
  * @description
  * triggerChange is the function called when the user clikc on pagination arrows or page numbers.
  * Get the current page number as selected by the ned user and get the Audit logs based on the Page number selected
  * @var pageNumber variable to store the selected page number as per the end user interaction
  * @callback getAuditLogList function to get the audit log list with new page number
  * @return null
  * @argument data $event data is used to get the current page number
  * @author gaurav.rao
  **/

  triggerChange(data: any) {
    this.pageNumber = data;
    this.getAuditLogList();
  }

  /**
   * @function ngOnDestroy()
   * @description
   * Function to destroy the Subscription used while calling API
   * Unsubscribe the observable is done using takeUntil method of rxjs
   * @author gaurav.rao
  */
  ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/audit-log/audit-log.component.ts